// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-QkhwBlkn","topContainer":"dp-a1i294DZ","collapseContent":"dp-kXNqECuF"};